<template>
    <div>
      <report-header @generate="load" @filterChanged="filterChanged"
        @onChangedDateStart="onChangedDateStart" @onChangedDateEnd="onChangedDateEnd" @onChangedGroup="onChangedGroup" @onChangedTypeTraffic="onChangedTypeTraffic"
        :filterOptions="filterOptions" :isGenerateDisabled="isGenerateDisabled" @paginationChanged="paginationChanged"/>
      <basic-table
        :items="traffic"
        :fields="trafficFields"
        :filter="filter"
        :perPage="perPage"
        :currentPage="currentPage"
        v-model="totalRows"/>
      <table-manager-bottom
        :totalRows="totalRows" :perPage="perPage"
        v-model="currentPage"/>
    </div>
</template>

<script>
export default {
  props: {
    userId: 0
  },
  data () {
    return {
      getStore: {
        numDateEnd: 0,
        numDateStart: 0,
        userId: 0,
        group_id: 0,
        type: 0,
        accounting_period_id: 0,
        account_id: 0
      },
      traffic: [],
      trafficFields: [
        {key: 'account_id', label: this.$i18n.t('Account ID'), sortable: true},
        {key: 'login', label: this.$i18n.t('Login'), sortable: true},
        {key: 'tclass', label: this.$i18n.t('Traffic class'), sortable: true},
        {key: 'bytes', label: this.$i18n.t('MBytes'), sortable: true},
        {key: 'base_cost', label: this.$i18n.t('Cost per unit mb'), sortable: true},
        {key: 'charge', label: this.$i18n.t('Sum'), sortable: true},
        {key: 'ip', label: 'IP', sortable: true}
      ],
      isGenerateDisabled: false,
      selectTypeTraffic: 0,
      selectGroup: 0,
      filter: null,
      perPage: 20,
      totalRows: 0,
      currentPage: 1,
      dateStart: new Date(),
      dateEnd: new Date(),
      filterOptions: {
        isFilterGroup: true,
        isFilterTypeTraffic: true,
        isFilterTypeDocuments: false,
        isFilterTypeUsers: false,
        isFilterCollector: false
      }
    }
  },
  methods: {
    async load () {
      this.isGenerateDisabled = true
      let numDateEnd = Number(this.dateEnd) / 1000
      if (numDateEnd > 2147483647) numDateEnd = 2147483647
      let numDateStart = Number(this.dateStart) / 1000
      if (numDateStart > 2147483647) numDateStart = 2147483647
      this.getStore.numDateEnd = numDateEnd
      this.getStore.numDateStart = numDateStart
      this.getStore.type = this.selectTypeTraffic
      if (!this.userId) {
        this.getStore.group_id = this.selectGroup
      } else {
        this.getStore.userId = this.userId
      }
      await this.$store.dispatch('Reports/GET_TRAFFIC', this.getStore).then(response => {
        this.traffic = this.$store.getters['Reports/TRAFFIC']
        for (let el of this.traffic) {
          el.bytes = Math.round(el.bytes / 1024)
        }
      })
      this.loadDone()
    },
    onChangedDateStart (value) {
      this.dateStart = value
    },
    onChangedDateEnd (value) {
      this.dateEnd = value
    },
    onChangedGroup (value) {
      this.selectGroup = (value)
    },
    onChangedTypeTraffic (value) {
      this.selectTypeTraffic = (value)
    },
    filterChanged (value) {
      this.filter = value
    },
    loadDone () {
      this.isGenerateDisabled = false
    },
    paginationChanged (value) {
      this.perPage = value
    }
  },
  mounted () {
    this.loadDone()
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/reports/services/traffic/main.vue